import { v4 } from 'uuid';

export type JsonPrimitive = string | number | boolean | null;
export type Json = 
  | JsonPrimitive
  | Json[]
  | { [key: string]: Json };

export type char<count extends number>=string;
export type int=number;
export type inet=string;
export type json=Json;
export type jsonb=Json;
export type serial=number;
export type table<T>={[name:string]:T};
export type varchar<count extends number>=string;
export type vec2=[number,number];
export type vec3=[number,number,number];
export type uuid=string;

export function uuid(){
	return v4();
}

//none of these do anything
//the magic happens when its parsed by model-meta-builder

export function uniqueKey(target:any, propertyKey:string){}
export function index(target:any, propertyKey:string){}

export const rest={
	secret(target:any, propertyKey:string){}, //don't exist in the public copy or rest
	fake(target:any, propertyKey:string){}, //the oppisite of secret only exist in the public copy and rest
	readonly(target:any, propertyKey:string){},
	writeonly(target:any, propertyKey:string){},
};
